'use client';
import Link from 'next/link';
import { IRepository } from '@/types';
import { IResourceDefinition } from '@/lib/repositoryBranchesApi';
import useOxenSession from '@/hooks/useOxenSession';

import Button from '@/ui/Button';
import DropdownMenu from '@/ui/DropdownMenu';
import { TriangleDownIcon, UploadIcon, ReaderIcon } from '@radix-ui/react-icons';

const AddFilesButton: React.FC<{
  repository: IRepository;
  resource: IResourceDefinition;
}> = ({ repository, resource }) => {
  const { authorization, config } = useOxenSession();

  const repoIsEmpty = repository?.latest_commit === null;
  const commitRef = resource.version;
  const canAddFiles = config?.file_upload_enabled && authorization.forRepository(repository).canEdit();
  const canAddNotebook = config?.notebooks_enabled && authorization.forRepository(repository).canCreateNotebooks();

  if (!canAddFiles && !canAddNotebook) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button.Basic nowrap small disabled={repoIsEmpty}>
          <span>Add files</span>
          <TriangleDownIcon />
        </Button.Basic>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        {canAddFiles && (
          <Link href={`/${repository.namespace}/${repository.name}/upload/${commitRef}/${resource.path}`}>
            <DropdownMenu.Item>
              <UploadIcon />
              Upload files
            </DropdownMenu.Item>
          </Link>
        )}
        {canAddNotebook && (
          <Link href={`/${repository.namespace}/${repository.name}/notebooks/new/${commitRef}/${resource.path}`}>
            <DropdownMenu.Item>
              <ReaderIcon />
              Create new notebook
            </DropdownMenu.Item>
          </Link>
        )}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default AddFilesButton;
